import { Component, Input, Output, EventEmitter } from '@angular/core'

type Tab = {
    label: string
    id: number
}

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
    @Input() tabs: Array<Tab> = []
    @Input() selectedTabId: number = -1
    @Output() onTabChange = new EventEmitter<any>()

    public handleTabChange(id: number): void {
        this.selectedTabId = id
        this.onTabChange.emit(this.selectedTabId)
    }
}
